import { INVESTMENT_QUOTES_V2_REDUCER_KEY } from './investmentQuotesV2Reducer';

export const getResourceStore = (state) => state[INVESTMENT_QUOTES_V2_REDUCER_KEY];
export const getLoadPending = (state) => getResourceStore(state).loadPending;
export const isLoading = (state) => getResourceStore(state).isLoading;
export const getLastSyncDate = (state) => getResourceStore(state).lastSyncDate;
export const getInvestmentQuotes = (state) => getResourceStore(state).resourcesById;
export const getInvestmentQuoteBySymbol = (state, symbol) => getResourceStore(state).resourcesById
  .find((quote) => quote.symbol && symbol && quote.symbol.toUpperCase() === symbol.toUpperCase());


